module.exports = __webpack_public_path__ + "static/media/not-found.78b0a513.svg";